module.exports = __webpack_public_path__ + "img/cover_1.7b0e5b62.png";